import { z } from 'zod';
/**
 * Sources d'import supportées. Lot 1 : Goodreads CSV uniquement.
 * (Kindle `My Clippings.txt` arrivera en Lot 2 via un flux dédié.)
 */
export const ImportSourceSchema = z.enum(['goodreads-csv']);
/**
 * Une ligne d'import qui n'a pas pu être rattachée à un livre du catalogue
 * (titre vide, échec de résolution…). Remontée au front pour résolution
 * manuelle ultérieure.
 */
export const UnresolvedImportItemSchema = z.object({
    title: z.string(),
    author: z.string(),
    isbn: z.string().nullable(),
    reason: z.string(),
});
/**
 * Bilan d'un import : combien de lignes lues, créées, ignorées (déjà
 * présentes dans la bibliothèque) et non résolues.
 */
export const ImportReportSchema = z.object({
    source: ImportSourceSchema,
    totalParsed: z.number().int().min(0),
    created: z.number().int().min(0),
    skipped: z.number().int().min(0),
    unresolved: z.array(UnresolvedImportItemSchema),
});
//# sourceMappingURL=import.schema.js.map